<script setup>
import router from '@/router';
import { ref, inject, onMounted } from 'vue';
import { useStore } from 'vuex';

/*Pricing chatgpt:  
input: $0.0015 / 1K tokens	
output: $0.002 / 1K tokens*/

defineOptions({
  name: 'ChatMenu',
});

const store = useStore();

const createNewChat = async () => {
  const response = await store.dispatch('post', {
    end_point: 'newChat',
    body_vars: {
      model: model.value,
    },
  });
  if (response && response.data && response.data.chat_id) {
    openChat(response.data.chat_id);
  } else {
    console.log('error creating new chat');
  }
};

const emitter = inject('emitter');
const deleteEventName = 'deleteChat';

emitter.on(`${deleteEventName}-yes`, async (chat_id) => {
  await store.dispatch('delete', {
    end_point: 'getChat',
    path_vars: {
      chat_id,
    },
  });
  store.commit('deleteMessages', { chat_id });
  router.go();
});
emitter.on(`${deleteEventName}-no`, () => {});

const deleteChat = async (chat_id) => {
  store.dispatch('modal/setModal', {
    title: 'Weet je het zeker?',
    text: `Je staat op het punt om chat (${chat_id}) te verwijderen, met alle berichten die daar in zitten!`,
    eventName: deleteEventName,
    param: chat_id,
    type: 'okcancel',
  });
};

const openChat = async (chat_id) => {
  router.push({ path: `/chat/${chat_id}` });
};

const chats = ref([]);
const models = store.state.models;
const model = ref(store.state.models[0]);

const selectupdate = (id) => {
  model.value = store.state.models[id];
};

onMounted(async () => {
  chats.value = await store.dispatch('get', {
    end_point: 'getChats',
  });
});
</script>
<template>
  <div class="full">
    <h1 class="title is-size-3-mobile is-size-2-tablet">ChatMenu</h1>
    <div v-if="chats && chats.length != 0">
      <div v-for="(chat, index) in chats" :key="index">
        <button class="button is-danger" @click="deleteChat(chat.chat_id)">
          delete
        </button>
        <button class="button" @click="openChat(chat.chat_id)">
          <span>id: {{ chat.chat_id }}</span>
          <span>model: {{ chat.model }}</span>

          <span>tokentotaal: {{ chat.total_tokens_sum }}</span>
          <span>completion: {{ chat.completion_tokens_sum }}</span>
          <span
            >kosten: $
            {{
              (chat.completion_tokens_sum / 1000) * 0.002 +
              (chat.total_tokens_sum / 1000) * 0.0015
            }}</span
          ></button
        ><br />
      </div>
    </div>

    <div>
      <pull-down
        :items="models"
        :label="'pick chatgpt model'"
        :default-value="0"
        @selectupdate="selectupdate"
      >
      </pull-down>
      <button class="button" @click="createNewChat">Nieuwe chat</button>
    </div>
  </div>
</template>
<style scoped>
button {
  display: inline-block;
  & span {
    margin: 0 10px;
  }
}
</style>
